export default __webpack_public_path__ + "static/media/avatar.3d0e54a8.jpeg";